import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('blocked', {
  template: require('./template.html'),
  name: 'blocked',
  computed: {
    ...mapGetters(['status']),
  },
  beforeRouteLeave(to, from, next) {
    // only allow user to logout if delinquent
    if (
      (['delinquent', 'expired', 'disabled'].includes(this.status) && to.name === 'app-login') ||
      !['delinquent', 'expired', 'disabled'].includes(this.status)
    ) {
      next();
    } else {
      // if delinquent, don't allow to go anywhere else
      next(false);
    }
  },
  data() {
    return {
      sad: true,
    };
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/blocked/index.js